export const toLocaleDateString = (date?: string): string | undefined =>
  date == null
    ? undefined
    : new Date(date).toLocaleDateString('no-NO', {
        timeZone: 'Europe/Oslo',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })

const norwegianMonthAbbreviations = [
  'jan',
  'feb',
  'mar',
  'apr',
  'mai',
  'jun',
  'jul',
  'aug',
  'sep',
  'okt',
  'nov',
  'des'
]

export const toCompactDuedateString = (date: string): string => {
  const parts = new Intl.DateTimeFormat('no-NO', {
    timeZone: 'Europe/Oslo',
    day: 'numeric',
    month: 'numeric'
  }).formatToParts(new Date(date))
  const day = parts.find((part) => part.type === 'day')?.value
  const month = Number(parts.find((part) => part.type === 'month')?.value)

  return `${day?.padStart(2, '0')}. ${norwegianMonthAbbreviations[month - 1]}`
}

export const toLocaleString = (date?: string): string | undefined =>
  date == null
    ? undefined
    : new Date(date).toLocaleString('no-NO', {
        timeZone: 'Europe/Oslo',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
export const toLocaleTimeString = (date?: string): string | undefined =>
  date == null
    ? undefined
    : new Date(date).toLocaleTimeString('no-NO', {
        timeZone: 'Europe/Oslo',
        hour: '2-digit',
        minute: '2-digit'
      })
export const formatDate = (date: Date): string => date.toISOString()
export const formatString = (date?: string): string | undefined => {
  if (date != null) {
    const dateObj = new Date(date)
    const offset = dateObj.getTimezoneOffset() * 60000
    const localDate = new Date(dateObj.getTime() - offset + 2 * 60 * 60 * 1000) // Adjust for UTC+2
    return localDate.toISOString().split('T')[0]
  }
  return undefined
}

export const getCurrentDate = (): string =>
  new Date()
    .toLocaleDateString('sv-SE', { timeZone: 'Europe/Oslo' })
    .slice(0, 10)

const normalizeDuedate = (duedate: string): string | undefined => {
  const normalized = duedate.slice(0, 10)
  return /^\d{4}-\d{2}-\d{2}$/.test(normalized) ? normalized : undefined
}

export const getSortedDuedates = (
  duedates: string[] | null | undefined
): string[] =>
  (duedates ?? [])
    .map(normalizeDuedate)
    .filter((duedate): duedate is string => duedate != null)
    .sort((a, b) => a.localeCompare(b))

export const getNearestDuedate = (
  duedates: string[] | null | undefined
): string | undefined => {
  const sortedDuedates = getSortedDuedates(duedates)
  if (sortedDuedates.length === 0) return undefined

  const today = getCurrentDate()
  return sortedDuedates.find((date) => date >= today) ?? sortedDuedates.at(-1)
}
